import { Alert, Box, MenuItem, TextField, Typography } from '@mui/material';
import { FC, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
	getSupersetDashboardsRequest,
	setSelectedSupersetDashboardId,
} from 'redux/reducers/superset/reducer';
import {
	getSelectedSupersetDashboard,
	getSupersetDashboards,
	getSupersetDashboardsLoading,
} from 'redux/reducers/superset/selectors';
import { endpoint } from 'services/endpoint';
import { WEB_API_URL } from 'services/constants/env';
import { Loader } from 'ui/Loader';
import { SupersetDashboardEmbed } from './SupersetDashboardEmbed';
import { getSupersetDomain } from './utils';

export const SupersetDashboard: FC = () => {
	const dispatch = useDispatch();

	const dashboards = useSelector(getSupersetDashboards);
	const dashboardsLoading = useSelector(getSupersetDashboardsLoading);
	const selectedDashboard = useSelector(getSelectedSupersetDashboard);

	const guestTokenUrl = useMemo(() => `${WEB_API_URL}${endpoint.superset.TOKEN}`, []);
	const supersetDomain = getSupersetDomain(selectedDashboard?.url);

	useEffect(() => {
		dispatch(getSupersetDashboardsRequest());
	}, [dispatch]);

	if (dashboardsLoading && !dashboards) return <Loader />;

	return (
		<Box sx={{ padding: '0' }}>
			<Box
				sx={{
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'space-between',
					gap: 2,
					mb: 0,
				}}
			>
				{/* <Typography variant="h5" sx={{}}>Dashboards</Typography> */}

				{/* {Boolean(dashboards?.length) && (
					<TextField
						select
						size="small"
						label="Dashboard"
						sx={{ minWidth: 280 }}
						value={selectedDashboard?.id ?? ''}
						onChange={(event) => dispatch(setSelectedSupersetDashboardId(event.target.value))}
					>
						{dashboards?.map((dashboard) => (
							<MenuItem key={dashboard.id} value={dashboard.id ?? ''}>
								{dashboard.name || dashboard.id}
							</MenuItem>
						))}
					</TextField>
				)} */}
			</Box>

			{!dashboards?.length && !dashboardsLoading && (
				<Alert severity="info">There are no dashboards available for your account.</Alert>
			)}

			{Boolean(dashboards?.length) && !selectedDashboard && (
				<Alert severity="info">Select a dashboard to display.</Alert>
			)}

			{selectedDashboard && !supersetDomain && (
				<Alert severity="error">
					The dashboard `{selectedDashboard.name || selectedDashboard.id}` has no valid Superset
					URL.
				</Alert>
			)}

			{selectedDashboard?.id && supersetDomain && (
				<SupersetDashboardEmbed
					key={dashboards?.[0]?.id}
					supersetDomain={dashboards?.[0]?.url ?? ''}
					dashboardId={dashboards?.[0]?.id ?? ''}
					guestTokenUrl={guestTokenUrl}
				/>
			)}
		</Box>
	);
};
